<script>
import options from './FormRadioGroup.options'
export default options
</script>

<template>
  <div class="kb-form-radio-group">
    <div class="Form__Element FormChoice">
      <fieldset>
        <legend v-if="legend" class="Form__Element__Caption">
          {{ legend }}
        </legend>

        <template v-for="(option, index) in radioOptions" :key="index">
          <div>
            <input
              class="FormChoice__Input FormChoice__Input--radio"
              type="radio"
              :name="fieldName"
              :value="option.value"
              v-model="localValue"
              :checked="modelValue === option.value"
              :id="`${fieldName}-${index}`"
              :disabled="readOnly"
            />
            <label :for="`${fieldName}-${index}`" class="FormChoice__Label">
              {{ option.label }}
            </label>
          </div>
        </template>
      </fieldset>

      <div aria-live="assertive">
        <p class="Form__Element__ValidationError"
            role="alert" 
            v-if="inputHasValidationErrors && isValidationError"
          >
          {{ errorMessageLabel }}
        </p>
      </div>

      <p
        class="kb-form__input-helptext kb-form__input-helptext--radio"
        v-if="helpMessageLabel"
      >
        {{ helpMessageLabel }}
      </p>

    </div>
  </div>
</template>
